import { Group, Loader, type MantineSize } from '@mantine/core'

type LXLoaderProps = {
  size?: MantineSize
}

export const LXLoader = ({ size = 'md' }: LXLoaderProps) => {
  return (
    <Group justify="center" p="xl">
      <Loader size={size} />
    </Group>
  )
}
